import Vue from 'vue'
import BoardViewV2Page from '@/views/BoardViewV2Page'
import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);
Vue.config.productionTip = false;
new Vue({
  render: h => h(BoardViewV2Page)
}).$mount('#app')